import React from 'react';
import Card from '@mui/material/Card';
import { CardProps } from '@mui/material/Card/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import { useLocale } from '@jucy-ui/components';
import { CTAButton } from '@/components/CTAButton';
import { useSiteLinkPrefix } from '@/hooks/useSiteLinkPrefix';
import { CmsFleetCategory } from '@/services/cms/models/CmsFleetCategory';
import { CardDescription } from './components/CardDescription';
import { CardImage } from './components/CardImage';
import { CardTitle } from './components/CardTitle';

const useResolveFleetCategoryPageLink = (fleetCategory: CmsFleetCategory) => {
    const addSiteLinkPrefix = useSiteLinkPrefix();
    const locale = useLocale();
    const localeSlug = locale.split('_')[0];
    const pageLink = fleetCategory.pages?.find((page) => page.locale === localeSlug);
    return addSiteLinkPrefix(pageLink ? pageLink.url : fleetCategory.pages?.[0]?.url);
};

export type FleetCategoryCardProps = CardProps & {
    fleetCategory: CmsFleetCategory;
};

export const FleetCategoryCard = ({ fleetCategory, elevation = 0, ...props }: FleetCategoryCardProps) => {
    const href = useResolveFleetCategoryPageLink(fleetCategory);

    return (
        <Card {...props} elevation={elevation}>
            {fleetCategory.scenicImage ? (
                <Link href={href}>
                    <CardImage src={fleetCategory.scenicImage} alt={fleetCategory.name} />
                </Link>
            ) : null}
            <CardContent sx={{ px: 0 }}>
                <CardTitle color={'inherit'} component={Link} href={href} variant="subtitle2">
                    {fleetCategory.name}
                </CardTitle>
                <CardDescription>{fleetCategory.shortDescription}</CardDescription>
            </CardContent>
            <CardActions sx={{ px: 0 }}>
                <CTAButton href={href} variant="contained">
                    View details
                </CTAButton>
            </CardActions>
        </Card>
    );
};
